import { Card, Grid, Space, Flex } from 'antd';
import React from 'react';
import { useTheme } from '../GlobalContext/ThemeContext';
import { ReactComponent as LogoWide } from '../../../Images/logo-wide.svg';
import { ReactComponent as LogoWideWhite } from '../../../Images/logo-wide-white.svg';
import { COLORS } from '../../../Constants/design';
import Typography from 'antd/es/typography/Typography';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const CommonWrapper = ({ children, forceOverflowScroll = false }) => {
    const { t } = useTranslation();
    const { isDarkMode, toggleDarkMode } = useTheme();
    const screens = useBreakpoint() || {};
    const location = useLocation();
    const isMessagesRoute = location.pathname === '/messages';

    return (
        <Flex
            vertical
            style={{
                width: '100%',
                maxWidth: '100dvw',
                minHeight: '100dvh',
                height: '100dvh',
                background: !screens.xs ? `url("https://www.transparenttextures.com/patterns/diamond-upholstery.png"), 
                    linear-gradient(135deg, ${isDarkMode ? `${COLORS.dark.background} 0%, #1a1a1a 100%` : '#e3eef9 0%, #2a588c 100%'})` : (isDarkMode ? COLORS.dark.background : '#FFFFFF'),
                padding: 0,
                margin: 0,
                overflowY: forceOverflowScroll ? 'auto' : (screens.xs ? 'auto' : 'hidden'),
                overflowX: 'hidden',
            }}
        >
            {/* Main content area */}
            <Flex
                flex={1}
                justify="center"
                align="center"
                style={{
                    padding: screens.xs ? 0 : 10,
                }}
            >
                <Card
                    style={{
                        width: '100%',
                        maxWidth: screens.xs ? '100%' : 400,
                        borderRadius: screens.xs ? 0 : 16, // Smoother corners
                        boxShadow: screens.xs ? 'none' : (isDarkMode ? '0 10px 30px rgba(0,0,0,0.5)' : '0 10px 30px rgba(0,0,0,0.1)'),
                        padding: '24px',
                        margin: screens.xs ? 0 : '0 10px',
                        background: isDarkMode ? COLORS.dark.surface : '#FFFFFF',
                        height: screens.xs ? '100%' : 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        // Glassy border effect in dark mode
                        border: screens.xs ? 'none' : isDarkMode ? `1px solid ${COLORS.dark.border}` : '1px solid #f0f0f0',
                    }}
                    styles={{
                        body: {
                            padding: screens.xs ? '0 10px' : 20,
                        },
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: 20 }}>
                        {!isDarkMode ? (
                            <LogoWide style={{ width: '80%' }} />
                        ) : (
                            <LogoWideWhite style={{ width: '80%' }} />
                        )}
                        <Text type="secondary" style={{ display: 'block', marginTop: 10 }}>
                            {t('log_in_to_your_account')}
                        </Text>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        {children}
                    </div>
                    <div
                        style={{
                            width: '100%',
                            padding: '16px 0 0 0',
                            borderTop: `1px solid ${isDarkMode ? COLORS.dark.border : '#f0f0f0'}`,
                        }}
                    >
                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                            <LanguageSwitcher />
                            <div
                                onClick={toggleDarkMode}
                                style={{
                                    cursor: 'pointer',
                                    fontSize: 20,
                                    color: isDarkMode ? '#fff' : '#000',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {isDarkMode ? <MoonOutlined /> : <SunOutlined />}
                            </div>
                        </Space>
                    </div>
                </Card>
            </Flex>
        </Flex>
    );
};

export default CommonWrapper;
